import { Route } from '@angular/router';

export const googleProfileRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'about',
  },
  {
    path: 'about',
    loadChildren: () => import('@rma/google/about'),
  },
  {
    path: 'connect',
    loadChildren: () => import('@rma/google/connect'),
  },
  {
    path: 'google-reviews',
    loadChildren: () => import('@rma/google/google-reviews'),
  },
];
